/* eslint-disable react/prop-types */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState
} from 'react';
import { useTranslator } from '@jutro/locale';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import _ from 'lodash';
import appConfig from 'app-config';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';

import messages from './WatercraftTableActionComponent.messages';
import styles from './WatercraftTableActionComponent.module.scss';
import metadata from './WatercraftTableActionComponent.metadata.json5';
import WatercraftPopupComponent from '../WatercraftPopupComponent/WatercraftPopupComponent';


function WatercraftTableActionComponent(props) {
    const {
        submissionVM,
        updateWizardData,
        syncWatercraft,
        watercraftQuestionSet,
        getUnderlyingPolicies,
        emptyWatercraftQuestionSet,
        onAdd,
        onEdit,
        onRemove,
        onCancel,
        createUnderlyingPolicy,
        validateAllWatercrafts,
        validateULPolicy,
        viewModelService,
        setDisableNextButton
    } = props;

    const {
        showProgressDialog
    } = MLModalService();
    const {
        clearAlerts,
        clearSuccessAlerts,
        addSuccessAlert,
    } = MLNotificationBlockUtil();

    const pupModel = _.get(submissionVM, 'lobData.personalUmbrella');
    const { watercrafts } = pupModel.coverables;
    const translator = useTranslator();
    const [isInEditMode, updateIsInEditMode] = useState(false);
    const [nextID, updateNextID] = useState(0);
    const watercraftTypeList = viewModelService.productMetadata.get('pc').types.getTypelist('PUPWatercraftType_PUE');
    const isGPA = appConfig.portalCode === 'GPA';
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [exposureVM, setExposureVM] = useState();
    const [isEdit, setIsEdit] = useState();
    const [watercraftToEdit, setWatercraftToEdit] = useState();


    const addAlert = (watercraft) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.itemHasBeenAdded, args: { item: `${watercraft.year} ${watercraft.make}` }}, 'watercraftLocationBusinessDetails');
    };

    const undoWatercraftRemoval = (watercraft) => {
        watercrafts.value.push(watercraft);
        clearAlerts();
    };

    const addRemovalAlert = (watercraft) => {
        clearSuccessAlerts();
        addSuccessAlert({...messages.itemHasBeenRemoved, args:{ item: `${watercraft.year} ${watercraft.make}` }}, 'removeWatercraftExposure', () => undoWatercraftRemoval(watercraft))
    };

    const resetEditingWatercraft = () => {
        watercrafts.forEach((wc) => {
            wc.isEditing = false;
        });
    };

    const onSaveWatercraft = () => {
        const watercraft = exposureVM;
        if (watercraft.ulPolicyFixID.value === 'new') {
            watercraft.ulPolicyFixID = undefined;
        }
        if (watercraft.aspects.valid && watercraft.aspects.subtreeValid) {
            if(validateAllWatercrafts){
                validateAllWatercrafts();
            }
            const watercraftPromise = syncWatercraft();
            showProgressDialog(platformMessages.waiting, watercraftPromise);
            watercraftPromise.then((wc) => {
                setExposureVM(wc);
                const op = isEdit ? 'Edit' : 'Add';
                MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_${op} Watercraft`);
                if (isInEditMode) {
                    clearSuccessAlerts();
                } else {
                    setTimeout(() => { 
                        addAlert(watercraft.value);
                        if(validateULPolicy){
                            validateULPolicy();
                        } 
                    }, 3000);
                }
            });
            updateWizardData(submissionVM);
            return true;
        }
        return false;
    };

    const addWatercraft = () => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Watercraft`);
        const newWatercraft = {
            tempID: nextID + 1
        };
        updateNextID(nextID + 1);
        const watercraftVM = viewModelService.create(newWatercraft, 'pc', 'metlife.edge.capabilities.common.plugin.dto.PUPWatercraftDTOML');
        watercraftVM.value.isModernProduct = submissionVM.value.isModernProduct_Ext
        resetEditingWatercraft();
        watercraftVM.value.isEditing = true;
        updateIsInEditMode(false);
        if (watercraftQuestionSet.length > 0) {
            watercraftVM.watercraftQuestionSet.value = watercraftQuestionSet;
        }
        watercrafts.value.push(watercraftVM.value);
        return watercraftVM;
    };

    const editWatercraft = (index) => {
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Edit Watercraft`);
        const watercraftVM = watercrafts.children[index.index];
        watercraftVM.value.isModernProduct = submissionVM.value.isModernProduct_Ext
        setWatercraftToEdit(_.clone(watercraftVM.value));

        resetEditingWatercraft();
        watercraftVM.value.isEditing = true;
        updateIsInEditMode(true);
        return watercraftVM;
    };

    const createExposureModal = (_exposureVM, _isEdit) => {
        setIsModalOpen(true);
        setExposureVM(_exposureVM);
        setIsEdit(_isEdit);
        updateIsInEditMode(_isEdit);
    }


    const getModal = () => {
        const watercraftModalTitle = isEdit ? `${translator(messages.EditWatercraftPopupHeader)}` : `${translator(messages.AddWatercraftPopupHeader)}`;

        const onRejectModal = () => {
            const index = watercrafts.value.indexOf(exposureVM.value);
            if (index !== -1) {
                if (isInEditMode) {
                    watercrafts.value[index] = watercraftToEdit;
                } else {
                    watercrafts.value.splice(index.index, 1);
                }
                updateWizardData(submissionVM);
                setIsModalOpen(false);
            }
        };
        const componentProps = {
            title: watercraftModalTitle,
            actionBtnLabel: isGPA ? messages.GPAButtonLabel : platformMessages.mlContinue,
            cancelBtnLabel: isGPA ? platformMessages.mlCancel : undefined,
            onSaveAction: onSaveWatercraft,
            CustomComponent: WatercraftPopupComponent,
            showFooterOnCustomComponent: true,
            viewModelService,
            overrideProps: {
                pupModel,
                watercraftVM: exposureVM,
                getUnderlyingPolicies,
                createUnderlyingPolicy,
                showActionRow: false
            },
            additionalStyle: 'customModalDialog',
            isOpen: isModalOpen,
            onReject: onRejectModal,
            onResolve: () => { setIsModalOpen(false)}
        };
        return (<FormModalPopover {...componentProps} />)
    };


    const onAddWatercraft = () => {
        if (onAdd) return onAdd(onCancel);
        const watercraftVM = addWatercraft();
        createExposureModal(watercraftVM, false);
        setDisableNextButton(false);
    };

    const onEditWatercraft = (index) => {
        if (onEdit) return onEdit(watercrafts.children[index.index].value, onCancel);
        const watercraftVM = editWatercraft(index);
        createExposureModal(watercraftVM, true);
        setDisableNextButton(false);
    };

    const onRemoveWatercraft = (index) => {
        if (onRemove) return onRemove(watercrafts.children[index.index].value, onCancel);
        MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Remove Excluded Watercraft`);
        const watercraftToRemove = watercrafts.value[index.index];
        watercrafts.value.splice(index.index, 1);
        addRemovalAlert(watercraftToRemove);
        setDisableNextButton(false);
        if (watercrafts.value.length === 0) {
            emptyWatercraftQuestionSet();
        }
        updateWizardData(submissionVM);
        if(validateAllWatercrafts){
            validateAllWatercrafts();
        }
        if(validateULPolicy){
            validateULPolicy();
        }
    };


    const generateWatercraftOverrides = () => {
        if (watercrafts.value) {
            const getTypeKeyDescription = (typeKeyName) => {
                return translator({
                    id: typeKeyName,
                    defaultMessage: typeKeyName
                });
            };

            const getYesNoAnswer = (val) => (val ? translator(messages.yes) : translator(messages.no));

            const overrides = watercrafts.value.map((watercraft, index) => {
                return {
                    [`typeCell${index}`]: {
                        content: (watercraft.watercraftType) ? getTypeKeyDescription(watercraftTypeList.getCode(watercraft.watercraftType).name) : ''
                    },
                    [`typeCellStatus${index}`]: {
                        visible: _.isString(watercraft.error)
                    },
                    [`yearCell${index}`]: {
                        content: watercraft.year
                    },
                    [`makeCell${index}`]: {
                        content: watercraft.make
                    },
                    [`modelCell${index}`]: {
                        content: watercraft.model
                    },
                    [`excludedCell${index}`]: {
                        content: getYesNoAnswer(watercraft.isExcluded)
                    },
                    [`editActionCell${index}`]: {
                        content: 'Edit',
                        'aria-labelledby': `typeCellContent${index} yearCellContent${index} makeCellContent${index} modelCellContent${index} excludedCellContent${index}`
                    },
                    [`removeActionCell${index}`]: {
                        content: 'Remove',
                        'aria-labelledby': `typeCellContent${index} yearCellContent${index} makeCellContent${index} modelCellContent${index} excludedCellContent${index}`
                    },
                };
            });
            return Object.assign({}, ...overrides);
        }
        return {};
    };

    const overrideProps = {
        watercraftHeader: {
            className: classNames('vertical-spacing-20', isGPA ? styles['section-header'] : styles['amp-section-header']),
            content: translator(messages.WatercraftHeader)
        },
        WatercraftTable: {
            className: watercrafts.length > 0 ? 'stack-table' : ''
        },
        watercraftsIterable: {
            data: watercrafts.value
        },
        headerRow:{
            visible: watercrafts.length>0
        },
        mlTableActionsDefaultButton: {
            className: 'display-inline-block margin-top-20',
            type: isGPA ? 'outlined' : 'filled',
            content: translator(messages.AddWatercraft),
            onClick: onAddWatercraft
        },
        watercraftParagraph: {
            visible: watercrafts.length <= 0,
            content: translator(messages.WatercraftParagraph)
        },
        ...generateWatercraftOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onEditWatercraft,
            onAddWatercraft,
            onRemoveWatercraft,
        },
        resolveClassNameMap: styles
    };

    return (
        <>
            <ViewModelForm
                uiProps={metadata.componentContent}
                model={submissionVM}
                overrideProps={overrideProps}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
                onModelChange={updateWizardData}
            />
            {isModalOpen && getModal()}
        </>
    );
}

WatercraftTableActionComponent.propTypes = {
    submissionVM: PropTypes.shape({}).isRequired,
    updateWizardData: PropTypes.func.isRequired,
    syncWatercraft: PropTypes.func.isRequired,
    watercraftQuestionSet: PropTypes.shape([]).isRequired,
    getUnderlyingPolicies: PropTypes.func,
    emptyWatercraftQuestionSet: PropTypes.func.isRequired,
    onAdd: PropTypes.func,
    onEdit: PropTypes.func,
    onRemove: PropTypes.func,
    onCancel: PropTypes.func,
};

export default WatercraftTableActionComponent;
